'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var debug = require('debug');

var profiles = require('./profiles.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:core:config');

function createConfig(_ref) {
  var repo = _ref.repo;
  return {
    getAll: withTimeoutOption.withTimeoutOption(getAll),
    get: withTimeoutOption.withTimeoutOption(get),
    set: withTimeoutOption.withTimeoutOption(set),
    replace: withTimeoutOption.withTimeoutOption(replace),
    profiles: {
      apply: withTimeoutOption.withTimeoutOption(applyProfile),
      list: withTimeoutOption.withTimeoutOption(listProfiles)
    }
  };

  function getAll() {
    return _getAll.apply(this, arguments);
  }

  function _getAll() {
    _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              return _context.abrupt("return", repo.config.getAll(options));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getAll.apply(this, arguments);
  }

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, options) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (key) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", Promise.reject(new Error('key argument is required')));

            case 2:
              return _context2.abrupt("return", repo.config.get(key, options));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _get.apply(this, arguments);
  }

  function set(_x3, _x4, _x5) {
    return _set.apply(this, arguments);
  }

  function _set() {
    _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, value, options) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", repo.config.set(key, value, options));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _set.apply(this, arguments);
  }

  function replace(_x6, _x7) {
    return _replace.apply(this, arguments);
  }

  function _replace() {
    _replace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value, options) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", repo.config.replace(value, options));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _replace.apply(this, arguments);
  }

  function applyProfile(_x8) {
    return _applyProfile.apply(this, arguments);
  }

  function _applyProfile() {
    _applyProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(profileName) {
      var options,
          dryRun,
          profile,
          oldCfg,
          newCfg,
          _args5 = arguments;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {
                dryRun: false
              };
              dryRun = options.dryRun;
              profile = profiles.profiles[profileName];

              if (profile) {
                _context5.next = 5;
                break;
              }

              throw new Error("No profile with name '".concat(profileName, "' exists"));

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return repo.config.getAll(options);

            case 8:
              oldCfg = _context5.sent;
              newCfg = JSON.parse(JSON.stringify(oldCfg));
              newCfg = profile.transform(newCfg);

              if (dryRun) {
                _context5.next = 14;
                break;
              }

              _context5.next = 14;
              return repo.config.replace(newCfg, options);

            case 14:
              delete oldCfg.Identity.PrivKey;
              delete newCfg.Identity.PrivKey;
              return _context5.abrupt("return", {
                original: oldCfg,
                updated: newCfg
              });

            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](5);
              log(_context5.t0);
              throw new Error("Could not apply profile '".concat(profileName, "' to config: ").concat(_context5.t0.message));

            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[5, 19]]);
    }));
    return _applyProfile.apply(this, arguments);
  }
}

function listProfiles(_x9) {
  return _listProfiles.apply(this, arguments);
}

function _listProfiles() {
  _listProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_options) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", Object.keys(profiles.profiles).map(function (name) {
              return {
                name: name,
                description: profiles.profiles[name].description
              };
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _listProfiles.apply(this, arguments);
}

exports.createConfig = createConfig;